module.exports = __webpack_public_path__ + "img/5_5.164a2ec1.png";